import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';
import { isABCSupported, isOpen } from './helpers';
import { isSwissVisitor } from 'lib/util/helpers';
import { renderMsgChannel } from './MsgChannel';
import { IMsgConfig } from './models';
import { renderChat } from './Chat';

function isDateWithYear(dateStr : string) : boolean {
	return /^\d{2}\.\d{2}\.\d{4}$/.test(dateStr);
}

function createExceptionallyOpenTimes(data : string[]) {
	// Expected array element is '11.11. 12.07. 06:00-18:00' or '12.12.2019 11.02. 06:00-18:00'
	const retArr : string[] = [];
	const year = (new Date()).getFullYear();
	for (const elem of data) {
		const exceptions = elem.split(' ');
		const exceptionsTime = exceptions.pop();
		exceptions.forEach(exception =>
			retArr.push(`${exception}${isDateWithYear(exception) ? '' : year} ${exceptionsTime}`));
	}

	// Exception array element is: 02.01.2019 07:00-19:59
	return retArr;
}
function createExceptionallyClosedTimes(data : string[]) {
	// Expected array element is '01.01. 02.01.' or '12.01.2019 12.04.'
	const retArr : string[] = [];
	const year = (new Date()).getFullYear();
	for (const elem of data) {
		elem.split(' ').forEach(close => retArr.push(`${close}${isDateWithYear(close) ? '' : year} closed`));
	}

	// Exception array element is: 21.05.2018 closed
	return retArr;
}

const MESSAGING_CHANNELS = [ 'wa', 'sms', 'abc' ];

export default class SMSAndChat extends Module {
	private $contentHolder! : JQuery;
	private isMobile! : boolean;

	public on(callback : Hook) {
		this.$contentHolder = this.$ctx.find('.content-holder');
		this.isMobile = this.$ctx.data('is-mobile');

		let displaySettings = isABCSupported() && this.$ctx.data('use-abc') ?
			this.$ctx.data('a-contact-channels') : this.$ctx.data('contact-channels');

		if(displaySettings[0] === 'chat') {
			renderChat(
				this.$contentHolder.get(0),
				this.$ctx.data('chat-title') || '',
				this.$ctx.data('chat-intro') || '',
				this.$ctx.data('chat-type'),
				this.$ctx.data('chat-genesys-style'),
				this.$ctx.data('chat-provider'),
				this.$ctx.data('chat-tracking'),
			);
		} else {
			const open = isOpen({
				exceptionallyClosed: createExceptionallyClosedTimes(this.$ctx.data('exceptions-closed')),
				exceptionallyOpen: createExceptionallyOpenTimes(this.$ctx.data('exceptions-open')),
				openhours: this.$ctx.data('open-time'),
			});
			const swissWisitor = isSwissVisitor();
			let introText;
			let additionalText;
			if (!swissWisitor) {
				introText = this.$ctx.data('intro-abroad') || '';
				additionalText = this.$ctx.data('addition-abroad') || '';
			} else if (open) {
				introText = this.$ctx.data('intro-open') || '';
				additionalText = this.$ctx.data('addition-open') || '';
			} else {
				introText = this.$ctx.data('intro-closed') || '';
				additionalText = this.$ctx.data('addition-closed') || '';
			}

			displaySettings = this.updateDisplayedConfig(displaySettings);
			const msgOptions = this.createMsgConfiguration(displaySettings);

			if(msgOptions.length) {
				renderMsgChannel(
					this.$contentHolder.get(0),
					this.$ctx.data('title') || '',
					introText,
					additionalText,
					msgOptions,
				);
			}
		}

		callback();
	}
	private updateDisplayedConfig(displaySettings : string[]) : string[] {
		for (const msgChannel of MESSAGING_CHANNELS) {
			if(!displaySettings.includes(msgChannel)) {
				continue;
			}
			const msgOpenTime = this.$ctx.data(`${msgChannel}-open-time`);
			const msgExceptionsClosed = this.$ctx.data(`${msgChannel}-exceptions-closed`);
			const msgExceptionsOpen = this.$ctx.data(`${msgChannel}-exceptions-open`);

			if ((msgOpenTime && msgOpenTime.length) ||
				(msgExceptionsClosed && msgExceptionsClosed.length) ||
				(msgExceptionsOpen && msgExceptionsOpen.length)) {
				const isMsgChannelOpen = isOpen({
					exceptionallyClosed: createExceptionallyClosedTimes(msgExceptionsClosed),
					exceptionallyOpen: createExceptionallyOpenTimes(msgExceptionsOpen),
					openhours: msgOpenTime,
				});

				if(!isMsgChannelOpen) {
					displaySettings = displaySettings.filter((el : string) => el !== msgChannel);
				}
			}
		}

		return displaySettings;
	}
	private createMsgConfiguration(displaySettings : string[]) : IMsgConfig[] {
		return displaySettings.filter(e => e !== 'none').map(val => {
			const res = {} as any;
			if(val === 'sms') {
				res.channel = val;
				res.type = this.$ctx.data('sms-type');
				res.tracking = this.$ctx.data('sms-tracking');
				res.label = this.$ctx.data('sms-label');
				if(!this.isMobile) {
					res.modalTitle = this.$ctx.data('modal-title');
					res.modalWidth = this.$ctx.data('modal-width');
					res.modalHeight = this.$ctx.data('modal-height');
					res.modalPath = this.$ctx.data('path-to-modal');
				} else {
					res.smsUrl = `sms:${this.$ctx.data('sms-number')}`;
				}
			}
			if(val === 'abc') {
				res.channel = val;
				res.abcUrl = this.$ctx.data('abc-url');
				res.tracking = this.$ctx.data('abc-tracking');
				res.label = this.$ctx.data('abc-label');
			}
			if(val === 'wa') {
				res.channel = val;
				res.tracking = this.$ctx.data('wa-tracking');
				res.label = this.$ctx.data('wa-label');
				res.waUrl = this.$ctx.data('wa-url');
				res.type = this.$ctx.data('wa-btn-type');
			}

			return res as IMsgConfig;
		});
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/contact/Tc.Module.SMSAndChat.ts